import { useQuery } from '@tanstack/react-query';
import { getMyNotifications } from '../api/notificationApi';

/**
 * The unread count and recent items, shared by the sidebar badge and the
 * top-bar bell.
 *
 * Deliberately the same query key the Notifications page invalidates after
 * mark-as-read, so all three stay in step from one cached poll rather than
 * three competing requests.
 */
export function useNotificationFeed({ enabled = true } = {}) {
  const query = useQuery({
    queryKey: ['notifications', 'week'],
    queryFn: () => getMyNotifications('week').then((r) => r.data),
    enabled,
    refetchInterval: 60_000,
    staleTime: 30_000,
  });

  const notifications = Array.isArray(query.data?.notifications)
    ? query.data.notifications
    : [];

  return {
    ...query,
    notifications,
    unread: query.data?.unread ?? 0,
  };
}

export default useNotificationFeed;
